import { render, staticRenderFns } from "./Backoffice.vue?vue&type=template&id=e3b61b9e&scoped=true&"
import script from "./Backoffice.vue?vue&type=script&lang=js&"
export * from "./Backoffice.vue?vue&type=script&lang=js&"
import style0 from "./Backoffice.vue?vue&type=style&index=0&id=e3b61b9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b61b9e",
  null
  
)

export default component.exports